export default __webpack_public_path__ + "static/media/gamblingIIE2.6d59510f.JPG";